import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import CRMApp from './components/CRMApp';
import AffiliateTripStatusPage from './components/affiliate/AffiliateTripStatusPage';
import RetiredPortal from './components/portal/RetiredPortal';
import AppInstallPage from './components/shared/AppInstallPage';
import { applyDoorFavicons, applyDoorIdentity } from './lib/doorIdentity';
import { doorForAddress } from './lib/signInDoors';
import { SaveToastHost } from './components/ui/SaveToast';
import './styles/global.css';

// The affiliate driver's no-login trip-status page.
//
// It is split off ABOVE CRMApp on purpose. CRMApp renders LoginScreen whenever
// there is no session, so anything routed inside it is behind the auth gate by
// construction — and the whole point of this page is that the person opening it
// has no account and never will. The token in the URL is the credential. Routed
// inside CRMApp, an affiliate driver would be shown a login form.
const AFFILIATE_TRIP_PATH_PREFIX = '/t/';

function AppRoutes() {
    const location = useLocation();
    useEffect(() => {
        // The tab icon follows the address on every page, including /portal and /install.
        applyDoorFavicons(doorForAddress(window.location), document, process.env.PUBLIC_URL || '');
        const manifest = document.querySelector('link[rel="manifest"]');
        if (!manifest) return;
        // The door is chosen by the address the person opened, as on the sign-in screen.
        applyDoorIdentity(doorForAddress(window.location), document, process.env.PUBLIC_URL || '', window.location.hostname);
    }, [location.pathname, location.search]);
    if (location.pathname === '/install') return <AppInstallPage />;

    if (location.pathname.startsWith(AFFILIATE_TRIP_PATH_PREFIX)) {
        return (
            <Routes>
                <Route path="/t/:token" element={<AffiliateTripStatusPage />} />
            </Routes>
        );
    }

    if (location.pathname === '/portal' || location.pathname.startsWith('/portal/')) {
        return <RetiredPortal />;
    }

    // Rendered directly rather than as the element of a catch-all <Route>, so
    // CRMApp keeps mounting exactly as it did before this page existed. Wrapping
    // it in a splat route would put its ~45 absolute route paths inside a nested
    // routing context, which is a large regression surface for no benefit.
    return <CRMApp />;
}

// BL-177 Step 2c (A5): the one save toast is mounted once, above every route (including /portal and
// /install), so any save anywhere can call saveToast.saved() / failed().
function App() {
    return (
        <>
            <AppRoutes />
            <SaveToastHost />
        </>
    );
}

export default App;
